import { styled } from "@mui/material/styles";
import IconTitleSvg from "assets/images/icons/check-badge.svg";

export const TitleContainer = styled("div", { label: "title-container" })`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  color: ${({ theme }) => theme.palette.color.primary[45]};
  padding-right: ${({ theme }) => theme.spacing(1.5)};
  flex-direction: row;
  position: relative;

  ${({ theme }) => theme.breakpoints.up("md")} {
    margin-bottom: ${({ theme }) => theme.spacing(2.5)};
    &::before {
      content: "";
      position: absolute;
      left: 0;
      right: 0;
      height: theme.spacing(0.125);
      background-color: ${({ theme }) => theme.palette.color.gray[85]};
      top: 100%;
    }
  }

  ${({ theme }) => theme.breakpoints.down("md")} {
    color: ${({ theme }) => theme.palette.color.gray[10]};
    &::before {
      content: "";
      position: absolute;
      left: ${({ theme }) => theme.spacing(2)};
      right: ${({ theme }) => theme.spacing(2.5)};
      height: theme.spacing(0.125);
      background-color: ${({ theme }) => theme.palette.color.gray[85]};
      top: 0%;
    }
  }
`;

export const TitleText = styled("h3", { label: "title-text" })`
  line-height: 1.2;
  font-weight: 500;
  font-size: 32px;
  padding-bottom: ${({ theme }) => theme.spacing(1.5)};
   ${({ theme }) => theme.breakpoints.down("md")} {
     padding-bottom: ${({ theme }) => theme.spacing(0)};
    margin-top: ${({ theme }) => theme.spacing(1.5)};
    font-size: 18px;
   
`;

export const TitleIcon = styled(IconTitleSvg, { label: "title-icon" })`
  fill: currentColor;
  align-self: start;
  width: ${({ theme }) => theme.spacing(4.5)};
  height: ${({ theme }) => theme.spacing(4.5)};
`;
